import { IFrames } from 'src/interfaces/global';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addFramesStyles, addPaddingStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledTable = styled.table<{ tableLayout?: string }>`
	position: relative;
	display: table;

	width: 100%;

	border-collapse: collapse;

	${addTransition()}

	${(p) => (p.tableLayout ? `table-layout: ${p.tableLayout};` : '')}

	& > thead {
		position: sticky;
		left: 0;
		right: 0;
		top: 0;
		z-index: 100;

		background-color: ${({ theme }) => theme.colors.carbon};
	}
`;

export const StyledRow = styled.tr<{
	isRowClickable?: any;
	isSelected?: boolean;
	isARowSelected?: boolean;
	forceSelectedRows?: boolean;
}>`
	position: relative;
	width: 100%;

	${({ isRowClickable }) =>
		isRowClickable
			? css`
					cursor: pointer;

					${addTransition()}

					@media (hover: hover) {
						&:hover {
							background-color: #282827;
						}
					}
			  `
			: ''}

	${({ isSelected, forceSelectedRows, isARowSelected }) =>
		isSelected || forceSelectedRows
			? css`
					background-color: #282827;
			  `
			: isARowSelected
			? `opacity: 0.5;`
			: ''}
`;

export const StyledCell = styled.td`
	${addTransition()}

	width: auto;

	${({ theme }) => `
			padding: ${theme.spacing['4xs']} ${theme.spacing['xs']};
			${mq(EMediaQuery.md, `padding: ${theme.spacing['4xs']} ${theme.spacing['3xs']}`)};
	`};
`;

export const StyledTableContainer = styled.div<IFrames>`
	position: relative;

	overflow-x: hidden;
	overflow-y: auto;

	${(p) => addFramesStyles(p)}
	${(p) => addPaddingStyles(p)}
`;

export const StyledThead = styled.thead<{ isHidden?: boolean }>`
	${mq(EMediaQuery.md, 'position: absolute; z-index: -1; pointer-events: none;')}

	${(p) => (p.isHidden ? 'position: absolute; z-index: -1;' : '')}
`;
